import { render } from "./HospitalItem.vue?vue&type=template&id=3c91284c&scoped=true&ts=true"
import script from "./HospitalItem.vue?vue&type=script&lang=ts"
export * from "./HospitalItem.vue?vue&type=script&lang=ts"

import "./HospitalItem.vue?vue&type=style&index=0&id=3c91284c&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\HESEL\\DCS\\Client\\vuejs-dcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c91284c"]])

export default __exports__